
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class FarPayResponseModel extends Model<FarPayResponseModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'error', type: 'string' },
		{ name: 'customers', type: 'FarPayCustomerModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new FarPayCustomerModel }, properties: () => { return FarPayCustomerModel.classProperties } }
	];
	[key: string]: any;
	
	public error: string;
	public customers: FarPayCustomerModel[];
    
	constructor(){
		super();
		this.error = '';
		this.customers = [];
		
	}
	getProperties(){
		return FarPayResponseModel.classProperties;
	}
}
export class FarPayCustomerModel extends Model<FarPayCustomerModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'number', isHidden: true },
		{ name: 'brandId', type: 'string' },
		{ name: 'customerNumber', type: 'string' },
		{ name: 'name', type: 'string' },
		{ name: 'email', type: 'string' },
		{ name: 'phoneNumber', type: 'string' },
		{ name: 'agreement', type: 'FarPayAgreementModel', isHidden: true, isObject: true, new: () => { return new FarPayAgreementModel }, properties: () => { return FarPayAgreementModel.classProperties } }
	];
	[key: string]: any;
	
	public id: number;
	public brandId?: string;
	public customerNumber: string;
	public name: string;
	public email: string;
	public phoneNumber: string;
	public agreement?: FarPayAgreementModel;
    
	constructor(){
		super();
		this.id = 0;
		this.brandId = undefined;
		this.customerNumber = '';
		this.name = '';
		this.email = '';
		this.phoneNumber = '';
		this.agreement = undefined;
		
	}
	getProperties(){
		return FarPayCustomerModel.classProperties;
	}
}
export class FarPayAgreementModel extends Model<FarPayAgreementModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'number', isHidden: true },
		{ name: 'status', type: 'string' },
		{ name: 'type', type: 'string' },
		{ name: 'startDate', type: 'Date' },
		{ name: 'endDate', type: 'Date' },
		{ name: 'details', type: 'string' }
	];
	[key: string]: any;
	
	public id: number;
	public status: string;
	public type: string;
	public startDate?: Date;
	public endDate?: Date;
	public details: string;
    
	constructor(){
		super();
		this.id = 0;
		this.status = '';
		this.type = '';
		this.startDate = undefined;
		this.endDate = undefined;
		this.details = '';
		
	}
	getProperties(){
		return FarPayAgreementModel.classProperties;
	}
}
export class FarPayInvoiceModel extends Model<FarPayInvoiceModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'number', isHidden: true },
		{ name: 'invoiceNumber', type: 'string' }
	];
	[key: string]: any;
	
	public id: number;
	public invoiceNumber: string;
    
	constructor(){
		super();
		this.id = 0;
		this.invoiceNumber = '';
		
	}
	getProperties(){
		return FarPayInvoiceModel.classProperties;
	}
}

